function tsvExport() {

    onmessage = function (message) {
        const { data, options } = message.data;
        let tsvData = tsvFunction(data, options);
        postMessage(tsvData);
        // Clear the data
        tsvData = undefined;
    };

    function escapeText(text) {
        if (!text) return "";
        text = text.replace(/\\/g, '\\\\');
        text = text.replace(/\n/g, "\\n");
        text = text.replace(/\t/g, "\\t");
        text = text.replace(/\r/g, "\\r");
        return text;
    }

    function computeRows(data) {

        const columns = data.head.vars;
        const tsvData = data.results.bindings.map(row => columns.map(col => row[col] && row[col].value ?
            escapeText(row[col].value)
            :
            ""));

        return tsvData.map(row => row.join("\t")).join("\n");
    }

    function computeHeaders(data) {

        const columns = data.head.vars;
        const tsvData = columns.map(column => column.replace(/_/g, ' ')).join("\t");
        return tsvData + "\n";
    }

    function tsvFunction(data, options) {
        const headers = options.includeHeaders ? computeHeaders(data) : "";
        const finalData = computeRows(data);
        return headers + finalData;
    }

}

export default tsvExport;